import React from 'react';
import { useFormikContext } from 'formik';
import TextField from '@mui/material/TextField';

function SelectFieldContext({
  name, label, children, onChangeCallback = () => {}, ...rest
}) {
  const { getFieldProps, getFieldMeta, setFieldValue } = useFormikContext();
  const fieldProps = getFieldProps(name);
  const fieldMeta = getFieldMeta(name);

  return (
    <TextField
      {...fieldProps}
      {...rest}
      select
      label={label}
      variant="outlined"
      onChange={(e) => {
        setFieldValue(name, e.target.value);
        onChangeCallback(e.target.value);
      }}
      fullWidth
      error={fieldMeta.touched && fieldMeta.error}
      helperText={fieldMeta.touched && fieldMeta.error}
    >
      {children}
    </TextField>
  );
}

export default SelectFieldContext;
